import { useEffect, useState } from "react";

const useCsrfToken = () => {
  const [csrfToken, setCsrfToken] = useState("");

  useEffect(() => {
    const tokenElement = document.querySelector("meta[name='csrf-token']");
    if (tokenElement) {
      setCsrfToken(tokenElement.getAttribute("content"));
    }
  }, []);

  return csrfToken;
};

export default useCsrfToken;



// WEBPACK FOOTER //
// ./app/javascript/bundles/hooks/useCsrfToken.jsx